import {sectionsMyConfiguration01, sectionsMyConfiguration02} from "./constants";

const ConfigurationMock = {
  settings: {
    client: "",
    projectId: "",
    projectName: "",
    shotsBaseUrl: "",
    thumbsBaseUrl: "",
  },
  user: {
    isLoggedIn: false,
    status: "PasswordRequired",
    units: [
      {
        id: 3,
        name: "",
      },
    ],
  },
  legalSettings: {
    legalAdviceUrl:
      "https://cdn.culmia.com/wp-content/uploads/2025/09/Aviso-Legal_2025_CULMIA.pdf",
    privacyPolicyUrl:
      "https://www.culmia.com/docs/Politica_de_Privacidad_Culmia_es.pdf",
    cookiesUrl: "https://www.culmia.com/es/politica-de-cookies",
    legalNote:
      "Este sitio web ha sido elaborado a partir de una representación virtual de una vivienda piloto, por lo que puede no corresponder con ninguna vivienda de la promoción ni con la seleccionada por el usuario. La visualización y/o apariencia de los materiales, los acabados y las calidades mostradas en las infografías pueden diferir de la realidad. El promotor se reserva el derecho de introducir modificaciones por otros materiales similares a los seleccionados como consecuencia de requerimientos y/o necesidades técnicas, constructivas, jurídicas, comerciales, de suministros y, en general, cualquier circunstancia que imposibilite la instalación de los materiales, acabados y calidades seleccionadas. La información gráfica y las imágenes contenidas en este documento tienen una finalidad puramente comercial y, por tanto, su carácter es orientativo y no vinculante, careciendo de valor contractual y/o precontractual.",
    summaryDisclaimerText1:
      "La presente personalización no tendrá validez hasta que esté firmada (y pagada si tiene sobrecoste) y adjuntada como adenda al contrato de compraventa suscrito por el COMPRADOR.",
    summaryDisclaimerText2:
      'Para el caso de que entre las opciones de personalización seleccionadas  (las "Opciones Seleccionadas") por el COMPRADOR, se incluyesen "opciones con coste", el coste de las mismas aparecerá reseñado en la presente Ficha. Este coste devengará IVA al mismo tipo impositivo que el que correspondiese a la vivienda.',
    summaryDisclaimerText3:
      'El importe correspondiente a las opciones con coste incrementarán de manera automática y desde la fecha de firma de la Ficha, el precio de compraventa de la vivienda. En caso de seleccionar "opciones con coste", su importe, más el IVA correspondiente aplicable, será satisfecho por el COMPRADOR  en el momento de la suscripción de la correspondiente escritura pública de compraventa de la vivienda, engrosando de esta forma la cantidad a abonar por el COMPRADOR  en dicho momento  según el contrato de compraventa suscrito. El incumplimiento de esta obligación de pago tendrá los mismos efectos que los establecidos para el impago del precio de compraventa en el contrato suscrito y además,  para el caso de resolución del contrato por incumplimiento del COMPRADOR, el importe total correspondiente a las "opciones con coste" seleccionadas, será detraído, en su totalidad, de las cantidades que, en su caso, proceda devolver al COMPRADOR según contrato suscrito, constituyendo la firma de la presente Ficha aceptación expresa del COMPRADOR  a las condiciones aquí establecidas que vienen a modificar lo dispuesto en el Contrato de Compraventa  firmado.',
    summaryDisclaimerText4:
      "El COMPRADOR declara expresamente conocer que VÍA CÉLERE no puede garantizar la disponibilidad de las Opciones Seleccionadas llegada la fecha de su suministro/instalación, que en todo caso dependerá de su mantenimiento en fabricación y distribución por parte de la marca fabricante. De acuerdo con lo anterior, en caso de que alguna/s de la/s Opción/es Seleccionada/s quedasen descatalogada/s o fuera de distribución, VÍA CÉLERE lo pondrá en conocimiento del COMPRADOR, facilitándole nueva/s opción/es en sustitución de la/s anterior/es, estableciendo en dicha comunicación el plazo máximo para formalizar la nueva selección mediante la suscripción de una nueva Ficha en sustitución de la actual. La falta de selección en dicho momento por una cualesquiera de las opciones facilitadas, determinará la selección sustitutoria por VÍA CÉLERE, a lo que desde ahora da su consentimiento expreso el COMPRADOR.",
    summaryDisclaimerText5:
      "El COMPRADOR igualmente declara expresamente conocer y aceptar que suscrita la presente Ficha: (i) no podrá modificar las Opciones Seleccionadas; y (ii) que las Opciones Seleccionadas pueden verse modificadas por exigencias de orden técnico, jurídico o comercial, así como aquellas que supongan cambios del Proyecto o de la memoria de calidades, autorizando el COMPRADOR a VÍA CÉLERE a efectuar las modificaciones que pudieran resultar de lo anterior que en ningún caso supondrán minoración de las calidades previstas en la memoria de calidades.",
    summaryDisclaimerText6:
      "Este documento ha sido elaborado a partir de una representación virtual de una vivienda piloto, por lo que puede no corresponder con ninguna vivienda de la promoción ni con la seleccionada por el usuario. La visualización y/o apariencia de los materiales, los acabados y las calidades mostradas en las infografías pueden diferir de la realidad. El promotor se reserva el derecho de introducir modificaciones por otros materiales similares a los seleccionados como consecuencia de requerimientos y/o necesidades técnicas, constructivas, jurídicas, comerciales, de suministros y, en general, cualquier circunstancia que imposibilite la instalación de los materiales, acabados y calidades seleccionadas. La información gráfica y las imágenes contenidas en este documento tienen una finalidad puramente comercial y, por tanto, su carácter es orientativo y no vinculante, careciendo de valor contractual y/o precontractual.",
  },
  rooms: [
    {
      id: "salon",
      name: "Salón",
      categories: [
        {
          id: "001",
          order: 1,
          hideInMenu: true,
        },
      ],
      cameras: [
        {
          id: "salon_01",
          isSummary: true,
          categories: [
            {
              id: "001",
              features: [
                {
                  id: "001001",
                },
                {
                  id: "001002",
                },
              ],
            },
          ],
        },
        {
          id: "salon_02",
        },
        {
          id: "salon_03",
        },
      ],
    },
    {
      id: "cocina",
      name: "Cocina",
      categories: [
        {
          id: "001",
          order: 1,
          hideInMenu: true,
        },
      ],
      cameras: [
        {
          id: "cocina_01",
        },
        {
          id: "cocina_02",
        },
        {
          id: "cocina_03",
        },
      ],
    },
    {
      id: "servicio-comun",
      name: "Baño Común",
      categories: [
        {
          id: "001",
          order: 1,
          hideInMenu: true,
        },
      ],
      cameras: [
        {
          id: "servicio-comun_01",
        },
        {
          id: "servicio-comun_02",
        },
      ],
    },
    {
      id: "suite",
      name: "Suite",
      categories: [
        {
          id: "001",
          order: 1,
          hideInMenu: true,
        },
      ],
      cameras: [
        {
          id: "suite_01",
          isSummary: true,
        },
        {
          id: "suite_02",
        },
      ],
    },
    {
      id: "servicio-suite",
      name: "Baño Suite",
      categories: [
        {
          id: "001",
          order: 1,
          hideInMenu: true,
        },
      ],
      cameras: [
        {
          id: "servicio-suite_01",
        },
        {
          id: "servicio-suite_02",
        },
      ],
    },
  ],
  categories: [
    {
      id: "009",
      name: "Suelos Vivienda",
      cameras: [
        {
          id: "salon_01",
          roomId: "salon",
        },
        {
          id: "salon_02",
          roomId: "salon",
        },
        {
          id: "salon_03",
          roomId: "salon",
        },
        {
          id: "suite_01",
          roomId: "suite",
        },
        {
          id: "suite_02",
          roomId: "suite",
        },
      ],
      selected_feature: "009001",
      features: [
        {
          id: "009001",
          name: "Suelo laminado HOME SALZBURG de Grupo Porcelanosa",
          description: "",
          thumb: "/thumbnails/_0000s_0000_Suelos_vivienda_Op_1.jpg",
          order: 1,
        },
        {
          id: "009002",
          name: "Suelo laminado RESIDENCE NEVADA de Grupo Porcelanosa",
          description: "",
          thumb: "/thumbnails/_0000s_0001_Suelos_vivienda_Op_2.jpg",
          order: 2,
        },
        {
          id: "009003",
          name: "Suelo laminado RESIDENCE ARIZONA de Grupo Porcelanosa",
          description: "",
          thumb: "/thumbnails/_0000s_0002_Suelos_vivienda_Op_3.jpg",
          order: 3,
        },
        {
          id: "009004",
          name: "Suelo laminado HOME KAPRUN de Grupo Porcelanosa",
          description: "",
          thumb: "/thumbnails/_0000s_0003_Suelos_vivienda_Op_4.jpg",
          order: 4,
        },
      ],
    },
    {
      id: "001",
      name: "Pintura paredes",
      cameras: [
        {
          id: "salon_01",
          roomId: "salon",
        },
        {
          id: "salon_02",
          roomId: "salon",
        },
        {
          id: "salon_03",
          roomId: "salon",
        },
        {
          id: "suite_01",
          roomId: "suite",
        },
        {
          id: "suite_02",
          roomId: "suite",
        },
      ],
      selected_feature: "001001",
      features: [
        {
          id: "001001",
          name: "Pintura general vivienda color 1 - RAL 9001 Crema",
          description: "",
          thumb: "/thumbnails/_0001s_0000_Pintura_paredes_Op_1.jpg",
          order: 1,
        },
        {
          id: "001002",
          name: "Pintura general vivienda color 2 - RAL 9010 Blanco",
          description: "",
          thumb: "/thumbnails/_0001s_0001_Pintura_paredes_Op_2.jpg",
          order: 2,
        },
        {
          id: "001003",
          name: "Pintura general vivienda color 3 - RAL 7035 Gris",
          description: "",
          thumb: "/thumbnails/_0001s_0002_Pintura_paredes_Op_3.jpg",
          order: 3,
        },
      ],
    },
    {
      id: "006",
      name: "Revestimientos baño secundario",
      cameras: [
        {
          id: "servicio-comun_01",
          roomId: "servicio-comun",
        },
        {
          id: "servicio-comun_02",
          roomId: "servicio-comun",
        },
      ],
      selected_feature: "006001",
      features: [
        {
          id: "006001",
          name: "BLANCO MATE 30X60 RECT y ONA BLANCO MATE 30X60 RECT en zona ducha de Azulejos Benadresa",
          description: "",
          thumb: "/thumbnails/_0008s_0000_Revestimientos_BC_Op_1.jpg",
          order: 1,
        },
        {
          id: "006002",
          name: "INNOVA SMOKE 30X60 RECT y STUCK INNNOVA GREY 30X60 RECT en zona ducha de Azulejos Benadresa",
          description: "",
          thumb: "/thumbnails/_0008s_0001_Revestimientos_BC_Op_2.jpg",
          order: 2,
        },
      ],
    },
    {
      id: "007",
      name: "Pavimento baño secundario",
      cameras: [
        {
          id: "servicio-comun_01",
          roomId: "servicio-comun",
        },
        {
          id: "servicio-comun_02",
          roomId: "servicio-comun",
        },
      ],
      selected_feature: "007001",
      features: [
        {
          id: "007001",
          name: "AVENUE GRIS 60X60 RECT Azulejos Benadresa",
          description: "AVENUE GRIS 60X60 RECT Azulejos Benadresa",
          thumb: "/thumbnails/_0009s_0000_Pavimentos_BC_Op_1.jpg",
          order: 1,
        },
        {
          id: "007002",
          name: "URANO SILVER 60X60 RECT Azulejos Benadresa",
          description: "URANO SILVER 60X60 RECT Azulejos Benadresa",
          thumb: "/thumbnails/_0009s_0001_Pavimentos_BC_Op_2.jpg",
          order: 2,
        },
      ],
    },
    {
      id: "003",
      name: "Pack cambio bañera por ducha",
      cameras: [
        {
          id: "servicio-comun_01",
          roomId: "servicio-comun",
        },
        {
          id: "servicio-comun_02",
          roomId: "servicio-comun",
        },
      ],
      selected_feature: "003001",
      features: [
        {
          id: "003001",
          name: "Sin opción",
          description: "",
          thumb: "/thumbnails/_0005s_0000_Pack_banera-ducha_Op_1.jpg",
          order: 1,
        },
        {
          id: "003002",
          name: "Plato ducha modelo WORK BASIC BB-NK PORCELANOSA medidas s/p",
          description: "",
          thumb: "/thumbnails/_0005s_0001_Pack_banera-ducha_Op_2.jpg",
          order: 2,
        },
      ],
    },
    {
      id: "004",
      name: "Revestimientos baño principal",
      cameras: [
        {
          id: "servicio-suite_01",
          roomId: "servicio-suite",
        },
        {
          id: "servicio-suite_02",
          roomId: "servicio-suite",
        },
      ],
      selected_feature: "004001",
      features: [
        {
          id: "004001",
          name: "REINE GREY 30X90 RECT Azulejos Benadresa",
          description: "",
          thumb: "/thumbnails/_0006s_0000_Revestimientos_BP_Op_1.jpg",
          order: 1,
        },
        {
          id: "004002",
          name: "REINE ALMOND 30X90 RECT Azulejos Benadresa",
          description: "",
          thumb: "/thumbnails/_0006s_0001_Revestimientos_BP_Op_2.jpg",
          order: 2,
        },
        {
          id: "004003",
          name: "REINE WALNUT 30X90 Azulejos Benadresa",
          description: "",
          thumb: "/thumbnails/_0006s_0002_Revestimientos_BP_Op_3.jpg",
          order: 3,
        },
      ],
    },
    {
      id: "005",
      name: "Pavimento baño principal",
      cameras: [
        {
          id: "servicio-suite_01",
          roomId: "servicio-suite",
        },
        {
          id: "servicio-suite_02",
          roomId: "servicio-suite",
        },
      ],
      selected_feature: "005001",
      features: [
        {
          id: "005001",
          name: "REINE GREY 60X60 RECT Azulejos Benadresa",
          description: "",
          thumb: "/thumbnails/_0007s_0000_Pavimentos_BP_Op_1.jpg",
          order: 1,
        },
        {
          id: "005002",
          name: "REINE WALNUT 60X60 RECT Azulejos Benadresa",
          description: "",
          thumb: "/thumbnails/_0007s_0001_Pavimentos_BP_Op_2.jpg",
          order: 2,
        },
      ],
    },
    {
      id: "010",
      name: "Pavimento Cocina",
      cameras: [
        {
          id: "cocina_01",
          roomId: "cocina",
        },
        {
          id: "cocina_03",
          roomId: "cocina",
        },
      ],
      selected_feature: "010001",
      features: [
        {
          id: "010001",
          name: "DOVER PEARL 60X60 RECT Azulejos Benadresa",
          description: "",
          thumb: "/thumbnails/_0003s_0000_Pavimento_cocina_Op_1.jpg",
          order: 1,
        },
        {
          id: "010002",
          name: "ABSTRACT SAND 60X60 RECT Azulejos Benadresa",
          description: "",
          thumb: "/thumbnails/_0003s_0001_Pavimento_cocina_Op_2.jpg",
          order: 2,
        },
      ],
    },
    {
      id: "002",
      name: "Muebles cocina",
      cameras: [
        {
          id: "cocina_01",
          roomId: "cocina",
        },
        {
          id: "cocina_02",
          roomId: "cocina",
        },
        {
          id: "cocina_03",
          roomId: "cocina",
        },
      ],
      selected_feature: "002001",
      features: [
        {
          id: "002001",
          name: "Melamina CINCOCINA color Blanco Brillo",
          description: "",
          thumb: "/thumbnails/_0002s_0000_Muebles_cocina_Op_1.jpg",
          order: 1,
        },
        {
          id: "002002",
          name: "Melamina CINCOCINA color Blanco Mate",
          description: "",
          thumb: "/thumbnails/_0002s_0001_Muebles_cocina_Op_2.jpg",
          order: 2,
        },
      ],
    },
    {
      id: "008",
      name: "Encimera",
      cameras: [
        {
          id: "cocina_01",
          roomId: "cocina",
        },
        {
          id: "cocina_02",
          roomId: "cocina",
          isPriority: true,
        },
        {
          id: "cocina_03",
          roomId: "cocina",
        },
      ],
      selected_feature: "008001",
      features: [
        {
          id: "008001",
          name: "Encimera COMPAC Plomo",
          description: "",
          thumb: "/thumbnails/_0004s_0000_Encimera_cocina_Op_1.jpg",
          order: 1,
        },
        {
          id: "008002",
          name: "Encimera COMPAC Alaska",
          description: "",
          thumb: "/thumbnails/_0004s_0001_Encimera_cocina_Op_2.jpg",
          order: 2,
        },
      ],
    },
  ],
  sections: [
    {
      id: "001",
      name: "Acabados paredes",
      categories: [
        {
          id: "002",
        },
        {
          id: "004",
        },
        {
          id: "006",
        },
      ],
    },
    {
      id: "002",
      name: "Equipamientos cocina",
      categories: [
        {
          id: "002",
        },
        {
          id: "008",
        },
      ],
    },
    {
      id: "003",
      name: "Equipamientos baños",
      categories: [
        {
          id: "003",
        },
      ],
    },
    {
      id: "004",
      name: "Pavimentos",
      categories: [
        {
          id: "005",
        },
        {
          id: "007",
        },
      ],
    },
  ],
  rules: [
    {
      categoryId: "002", // PAVIMENTO COCINA
      featureId: "002004", // Parquet laminado 1 lama Mod. Easy Line 832 Woodbridge Oak de Tarkett
      rule: {
        condition: "AVAILABLE_IF", // AVAILABLE IF (SÓLO DISPONIBLE SI)
        affects: [
          {
            categoryId: "005", // COCINA ABIERTA/CERRADA
            featureId: "005002", // Cocina abierta al salón
          },
          {
            logic: "OR",
            categoryId: "005", // COCINA ABIERTA/CERRADA
            featureId: "005003", // Cocina abierta al salón con barra
          },
          {
            logic: "AND",
            categoryId: "001", // PAVIMENTOS GENERALES VIVIENDA
            featureId: "001001", // Parquet laminado 1 lama Mod. Easy Line 832 Woodbridge Oak de Tarkett
          },
        ],
      },
    },
    {
      categoryId: "002", // PAVIMENTO COCINA
      featureId: "002005", // Parquet laminado 1 lama Mod. Easy Line 832 Woodbridge Oak de Tarkett
      rule: {
        condition: "AVAILABLE_IF", // AVAILABLE IF (SÓLO DISPONIBLE SI)
        affects: [
          {
            categoryId: "005", // COCINA ABIERTA/CERRADA
            featureId: "005002", // Cocina abierta al salón
          },
          {
            logic: "OR",
            categoryId: "005", // COCINA ABIERTA/CERRADA
            featureId: "005003", // Cocina abierta al salón con barra
          },
          {
            logic: "AND",
            categoryId: "001", // PAVIMENTOS GENERALES VIVIENDA
            featureId: "001002", // Parquet laminado 1 lama Mod. Easy Line 832 Woodbridge Oak de Tarkett
          },
        ],
      },
    },
    {
      categoryId: "002", // PAVIMENTO COCINA
      featureId: "002006", // Parquet laminado 1 lama Mod. Easy Line 832 Woodbridge Oak de Tarkett
      rule: {
        condition: "AVAILABLE_IF", // AVAILABLE IF (SÓLO DISPONIBLE SI)
        affects: [
          {
            categoryId: "005", // COCINA ABIERTA/CERRADA
            featureId: "005002", // Cocina abierta al salón
          },
          {
            logic: "OR",
            categoryId: "005", // COCINA ABIERTA/CERRADA
            featureId: "005003", // Cocina abierta al salón con barra
          },
          {
            logic: "AND",
            categoryId: "001", // PAVIMENTOS GENERALES VIVIENDA
            featureId: "001003", // Parquet laminado 1 lama Mod. Easy Line 832 Woodbridge Oak de Tarkett
          },
        ],
      },
    },
    {
      categoryId: "002", // PAVIMENTO COCINA
      featureId: "002007", // Parquet laminado 1 lama Mod. Easy Line 832 Woodbridge Oak de Tarkett
      rule: {
        condition: "AVAILABLE_IF", // AVAILABLE IF (SÓLO DISPONIBLE SI)
        affects: [
          {
            categoryId: "005", // COCINA ABIERTA/CERRADA
            featureId: "005002", // Cocina abierta al salón
          },
          {
            logic: "OR",
            categoryId: "005", // COCINA ABIERTA/CERRADA
            featureId: "005003", // Cocina abierta al salón con barra
          },
          {
            logic: "AND",
            categoryId: "001", // PAVIMENTOS GENERALES VIVIENDA
            featureId: "001004", // Parquet laminado 1 lama Mod. Easy Line 832 Woodbridge Oak de Tarkett
          },
        ],
      },
    },
    {
      categoryId: "005", // COCINA ABIERTA/CERRADA
      featureId: "005001", // Cocina semi-cerrada
      rule: {
        condition: "AVAILABLE_IF", // AVAILABLE IF (SÓLO DISPONIBLE SI)
        affects: [
          {
            categoryId: "002", // PAV COCINA
            featureId: "002001", // 1
          },
          {
            logic: "OR",
            categoryId: "002", // PAV COCINA
            featureId: "002002", // 2
          },
          {
            logic: "OR",
            categoryId: "002", // PAV COCINA
            featureId: "002003", // 3
          },
        ],
      },
    },
    {
      categoryId: "001", // Pav Generales
      featureId: "001001", // 1
      rule: {
        condition: "AVAILABLE_IF", // AVAILABLE IF (SÓLO DISPONIBLE SI)
        affects: [
          {
            categoryId: "002", // PAV COCINA
            featureId: "002004", // 4
          },
          {
            logic: "OR",
            categoryId: "002", // PAV COCINA
            featureId: "002001", // 1
          },
          {
            logic: "OR",
            categoryId: "002", // PAV COCINA
            featureId: "002002", // 2
          },
          {
            logic: "OR",
            categoryId: "002", // PAV COCINA
            featureId: "002003", // 3
          },
        ],
      },
    },
    {
      categoryId: "001", // Pav Generales
      featureId: "001002", // 1
      rule: {
        condition: "AVAILABLE_IF", // AVAILABLE IF (SÓLO DISPONIBLE SI)
        affects: [
          {
            categoryId: "002", // PAV COCINA
            featureId: "002005", // 5
          },
          {
            logic: "OR",
            categoryId: "002", // PAV COCINA
            featureId: "002001", // 1
          },
          {
            logic: "OR",
            categoryId: "002", // PAV COCINA
            featureId: "002002", // 2
          },
          {
            logic: "OR",
            categoryId: "002", // PAV COCINA
            featureId: "002003", // 3
          },
        ],
      },
    },
    {
      categoryId: "001", // Pav Generales
      featureId: "001003", // 1
      rule: {
        condition: "AVAILABLE_IF", // AVAILABLE IF (SÓLO DISPONIBLE SI)
        affects: [
          {
            categoryId: "002", // PAV COCINA
            featureId: "002006", // 6
          },
          {
            logic: "OR",
            categoryId: "002", // PAV COCINA
            featureId: "002001", // 1
          },
          {
            logic: "OR",
            categoryId: "002", // PAV COCINA
            featureId: "002002", // 2
          },
          {
            logic: "OR",
            categoryId: "002", // PAV COCINA
            featureId: "002003", // 3
          },
        ],
      },
    },
    {
      categoryId: "001", // Pav Generales
      featureId: "001004", // 1
      rule: {
        condition: "AVAILABLE_IF", // AVAILABLE IF (SÓLO DISPONIBLE SI)
        affects: [
          {
            categoryId: "002", // PAV COCINA
            featureId: "002007", // 6
          },
          {
            logic: "OR",
            categoryId: "002", // PAV COCINA
            featureId: "002001", // 1
          },
          {
            logic: "OR",
            categoryId: "002", // PAV COCINA
            featureId: "002002", // 2
          },
          {
            logic: "OR",
            categoryId: "002", // PAV COCINA
            featureId: "002003", // 3
          },
        ],
      },
    },
  ],
  prices: [
    {
      categoryId: "002",
      featureId: "002004",
      hasPrice: true,
      price: 69.95,
    },
  ],
  summaryCameras: [
    {
      id: "salon_01",
    },
    {
      id: "cocina_01",
    },
  ],
  printingCameras: [
    {
      id: "servicio-comun_01",
      roomId: "servicio-comun",
    },
    {
      id: "salon_01",
      roomId: "vivienda",
    },
    {
      id: "cocina_01",
      roomId: "cocina",
    },
    {
      id: "servicio-suite_01",
      roomId: "servicio-suite",
    },
    {
      id: "suite_01",
      roomId: "vivienda",
    },
  ],
};
export default ConfigurationMock;
